import React from "react";
import { Link } from "react-router-dom";

const CountriesBar = () => {
    return (
        <div className="countries-bar">
            <Link to='/countries/A' >
                <p>A</p>
            </Link>
            <Link to='/countries/B' >
                <p>B</p>
            </Link>
            <Link to='/countries/C' >
                <p>C</p>
            </Link>
            <Link to='/countries/D' >
                <p>D</p>
            </Link>
            <Link to='/countries/E' >
                <p>E</p>
            </Link>
            <Link to='/countries/F' >
                <p>F</p>
            </Link>
            <Link to='/countries/G' >
                <p>G</p>
            </Link>
            <Link to='/countries/H' >
                <p>H</p>
            </Link>
            <Link to='/countries/I' >
                <p>I</p>
            </Link>
            <Link to='/countries/J' >
                <p>J</p>
            </Link>
            <Link to='/countries/K' >
                <p>K</p>
            </Link>
            <Link to='/countries/L' >
                <p>L</p>
            </Link>
            <Link to='/countries/M' >
                <p>M</p>
            </Link>
            <Link to='/countries/N' >
                <p>N</p>
            </Link>
            <Link to='/countries/O' >
                <p>O</p>
            </Link>
            <Link to='/countries/P' >
                <p>P</p>
            </Link>
            <Link to='/countries/Q' >
                <p>Q</p>
            </Link>
            <Link to='/countries/R' >
                <p>R</p>
            </Link>
            <Link to='/countries/S' >
                <p>S</p>
            </Link>
            <Link to='/countries/T' >
                <p>T</p>
            </Link>
            <Link to='/countries/U' >
                <p>U</p>
            </Link>
            <Link to='/countries/V' >
                <p>V</p>
            </Link>
            <Link to='/countries/W' >
                <p>W</p>
            </Link>
            <Link to='/countries/X' >
                <p>X</p>
            </Link>
            <Link to='/countries/Y' >
                <p>Y</p>
            </Link>
            <Link to='/countries/Z' >
                <p>Z</p>
            </Link>
            
        </div>
    )
}

export default CountriesBar